// Light theme colors (default)
const lightTheme = {
  backgroundLight: "#ffffff",
  background: "#fafafa",
  backgroundDark: "rgb(234,234,234)",

  textDark: "#171717", //neutral-900
  text: "#525252", //neutral-600
  textLight: "#737373", //neutral-500
  textDisabled: "#d4d4d4", //neutral-300

  textInverted: "#F9FAFA",

  primaryDark: "#4f46e5", //indigo-800
  primary: "#4f46e5", //indigo-600
  primaryLight: "#6366f1", //indigo-500
  primaryLighter: "#a5b4fc", //indigo-300

  success: "#009140",
  successBorder: "#75b691",
  successBackground: "#e2ffe3",

  warning: "#ffc021",

  error: "rgb(224, 49, 48)",
  errorBorder: "rgb(213,149,140)",
  errorBackground: "#ffe3e2",
};

// Dark theme colors (soft charcoal palette)
const darkTheme = {
  backgroundLight: "#262626", //neutral-800 - soft charcoal
  background: "#1a1a1a", //darker charcoal
  backgroundDark: "#0a0a0a", //near black

  textDark: "#fafafa", //neutral-50 - inverted: near white
  text: "#e5e5e5", //neutral-200 - inverted: light gray
  textLight: "#a3a3a3", //neutral-400 - inverted: medium gray
  textDisabled: "#525252", //neutral-600 - inverted: dark gray

  textInverted: "#171717", //dark text for light backgrounds

  primaryDark: "#6366f1", //indigo-500 - slightly brighter for dark mode
  primary: "#6366f1", //indigo-500
  primaryLight: "#818cf8", //indigo-400
  primaryLighter: "#a5b4fc", //indigo-300

  success: "#10b981", //emerald-500 - brighter for dark mode
  successBorder: "#34d399", //emerald-400
  successBackground: "#064e3b", //emerald-900

  warning: "#fbbf24", //amber-400 - brighter for dark mode

  error: "#ef4444", //red-500
  errorBorder: "#f87171", //red-400
  errorBackground: "#7f1d1d", //red-900
};

// Export light theme as default for backwards compatibility
// Also export both themes so they can be accessed if needed
module.exports = lightTheme;
module.exports.lightTheme = lightTheme;
module.exports.darkTheme = darkTheme;
